"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormatNumber = useFormatNumber;
var _formatters = require("../formatters");
var _useCulture = require("./useCulture");
/**
 * Returns parameter `value` formatted as general number.
 * @see {@link formatNumber} for more information.
 *
 * @param value Numeric value to format
 * @param options Additional formatting options
 * @returns `value` formatted as general number
 * @example
  // basic usage
  useFormatNumber(1234.567);

  // specify number of decimals to display
  useFormatNumber(1234.567, { decimals: 2 })
 */
function useFormatNumber(value, options) {
  const {
    culture
  } = (0, _useCulture.useCulture)();
  return (0, _formatters.formatNumber)(value, culture, options);
}
//# sourceMappingURL=useFormatNumber.js.map